<template>
  <div class="flex-space-between pages" style="flex-wrap:wrap">
    <div v-for="page in pages" class="page" @click="openPage(page.pageId)"
         data-growing-container :data-growing-title="page.title">
      <image-with-loading
        class="image"
        :src="'https://m2.ikea.cn/' + page.image.url"
        :width="16"
        :height="9"
      />
      <div class="title">{{page.title}}</div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import mbff from "@/libs/mbff"
const router = require("@/libs/router");
import ImageWithLoading from "@/components/ImageWithLoading";

export default {
  props: ["config"],
  components: {
    ImageWithLoading
  },
  data() {
    return {
      pages: []
    };
  },
  mounted() {
    var self = this;
    const pageIds = this.config.pages;
    if (!this.config.pages) return
    this.config.pages = this.config.pages.filter(page => !!page.id)
    var requests = this.config.pages.map(page => {
      return mbff.get(`/content/cms/page/${page.id}`);
    });
    axios.all(requests).then(
      axios.spread((...responses) => {
        const pages = responses.map(res => {
          return res.data;
        });
        self.update(pages);
      })
    );
  },
  methods: {
    update(pages) {
      pages.forEach(page => {
        page.image =
          page.coverImage ||
          page.content.filter(config => {
            return (
              config.type == "image" ||
              config.type == "image-text" ||
              config.type == "hero"
            );
          })[0].image;
      });
      this.pages = pages;
    },
    openPage(id) {
      router.open("cms_page", {
        id: id
      });
    }
  }
};
</script>

<style scoped>
.pages {
  padding: 0px 20px;
}
.page {
  width: 48%;
  overflow: hidden;
  margin-bottom: 13px;
}

.image {
  border-radius: 6px;
  overflow: hidden;
}

.title {
  text-align: center;
  font-size: 12px;
  padding: 6px 10px;
  /* font-weight: bold; */
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/PageListComponent.vue